import CheckroomIcon from "@mui/icons-material/Checkroom";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import GridViewIcon from "@mui/icons-material/GridView";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import lightDarkFabricsImage from "assets/images/dtf/dtf-bot-light-dark-fabrics.png";
import softProductsImage from "assets/images/dtf/dtf-bot-soft-products.png";
import uploadDesignImage from "assets/images/dtf/dtf-bot-upload-design.png";

const SHEET_WIDTH_IN = 22;
const PRICE_PER_SQ_IN = 0.01;
const MIN_QUANTITY = 1;
const UI_PPI = 30;
const EXPORT_DPI = 300;
const DESIGN_GAP_IN = 0.15;
const ARTWORK_CHECK_FEE = 10;
const MAX_UPLOAD_DESIGNS = 40;

// x / (22 * height) = 0.01  →  x = 0.01 * 22 * height
const GANG_SHEET_PRICES = {
  20: 4.4,
  30: 6.6,
  40: 8.8,
  50: 11,
  60: 13.2,
  70: 15.4,
  80: 17.6,
  90: 19.8,
  100: 22,
  110: 24.2,
  120: 26.4,
  130: 28.6,
  140: 30.8,
  150: 33,
  160: 35.2,
  170: 37.4,
  180: 39.6,
  190: 41.8,
  200: 44,
};

const SHEET_LENGTHS = Array.from({ length: 19 }, (_, index) => 20 + index * 10);

const SHEET_SIZES = SHEET_LENGTHS.map((length) => ({
  id: `22x${length}`,
  label: `22 in × ${length} in`,
  width: SHEET_WIDTH_IN,
  height: length,
}));

const FEATURES = [
  {
    icon: CheckroomIcon,
    label: "Works on Any Fabric or Color",
  },
  {
    icon: AutoAwesomeIcon,
    label: "Vibrant Colors & Ultra-fine Details",
  },
  {
    icon: LocalLaundryServiceIcon,
    label: "Certified for 100+ Washes",
  },
  {
    icon: VerifiedUserIcon,
    label: "100% ECO Friendly (Made By Certified Inks)",
  },
  {
    icon: AttachMoneyIcon,
    label: "Starting at $4.40 per sheet",
  },
  {
    icon: GridViewIcon,
    label: "Nest multiple designs on one gang sheet",
  },
  {
    icon: DashboardCustomizeIcon,
    label: "AI tools: BG remove, upscale, halftone, fitcheck",
  },
];

const PRODUCT_IMAGES = [
  {
    src: lightDarkFabricsImage,
    alt: "Works on Both Light & Dark Fabrics",
  },
  {
    src: softProductsImage,
    alt: "Perfect for Customizing Soft Products",
  },
  {
    src: uploadDesignImage,
    alt: "Upload and arrange your designs",
  },
];

const FITCHECK_APPAREL = [
  { id: "tshirt-white", label: "White T-Shirt", color: "#f5f5f5", ink: "#222" },
  { id: "tshirt-black", label: "Black T-Shirt", color: "#1f2937", ink: "#fff" },
  { id: "hoodie-navy", label: "Navy Hoodie", color: "#1e3a5f", ink: "#fff" },
  { id: "tee-red", label: "Red Tee", color: "#b91c1c", ink: "#fff" },
];

export {
  SHEET_WIDTH_IN,
  PRICE_PER_SQ_IN,
  MIN_QUANTITY,
  UI_PPI,
  EXPORT_DPI,
  DESIGN_GAP_IN,
  ARTWORK_CHECK_FEE,
  MAX_UPLOAD_DESIGNS,
  GANG_SHEET_PRICES,
  SHEET_SIZES,
  FEATURES,
  PRODUCT_IMAGES,
  FITCHECK_APPAREL,
};
